<lib-unauthenticated-layout [backgroundImageUrl]="backgroundImageUrl" [title]="title">
  <div title>
    <h2 class="text-center text-3xl font-bold tracking-tight text-gray-900 dark:text-gray-100">
      {{ title || ('auth.login.title' | translate) }}
    </h2>
    <p class="mt-2 text-center text-sm text-gray-500 dark:text-gray-400">
      Accede con tus credenciales para continuar
    </p>
  </div>

  <div content>
    <div class="mx-auto flex w-full max-w-sm flex-col space-y-5">
      <p-button (onClick)="onAzureLogin()" [outlined]="true" styleClass="w-full" type="button">
        <div class="flex items-center justify-center gap-2">
          <img
            alt="Azure"
            class="h-5 w-5 object-contain"
            ngSrc="assets/images/azure-1.svg"
            width="20"
            height="20"
          />
          <span class="font-semibold">Ingresar con Azure</span>
        </div>
      </p-button>
      <ng-content select="[login-extra]"></ng-content>
    </div>
  </div>
</lib-unauthenticated-layout>
